export default function getRequestParams({
  requestParamsSet,
  query,
  key,
  queryKey,
}: {
  requestParamsSet: Record<string, string | number>;
  query: Record<string, string | number>;
  key: string;
  queryKey?: string;
}): string | number | undefined {
  return key in requestParamsSet ? requestParamsSet[key] || query[queryKey || key] || undefined : undefined;
}
